import { PAYOUT_LOG } from 'utils/StaticApiEndpoints';
import { showErrorAlert } from '../../../utils/AlertUtils';
import requestApi from '../../../utils/Request';
import {
  failurePayoutLogList,
  requestPayoutLogList,
  responsePayoutLogList,
} from '../../slices/payoutLogSlice/payoutLogSlice';

export const GetPayoutLogList = (params) => {
  return (dispatch) => {
    dispatch(requestPayoutLogList());
    requestApi
      .get(PAYOUT_LOG, { params })
      .then((response) => {
        dispatch(responsePayoutLogList(response));
      })
      .catch((error) => {
        dispatch(failurePayoutLogList(error));
        showErrorAlert(error?.message || 'Failed to load payout logs');
      });
  };
};
